import { render, staticRenderFns } from "./LinkFacebookCampaign.vue?vue&type=template&id=0370ee02&scoped=true"
import script from "./LinkFacebookCampaign.vue?vue&type=script&lang=js"
export * from "./LinkFacebookCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0370ee02",
  null
  
)

export default component.exports